import { render, staticRenderFns } from "./electricalSafetyPreview.vue?vue&type=template&id=cbea8766&scoped=true"
import script from "./electricalSafetyPreview.vue?vue&type=script&lang=js"
export * from "./electricalSafetyPreview.vue?vue&type=script&lang=js"
import style0 from "./electricalSafetyPreview.vue?vue&type=style&index=0&id=cbea8766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbea8766",
  null
  
)

export default component.exports